import React from 'react'
import './myconnections.css'
import Connectors from './Connectors/Connectors'

const ConnectorPanel = () => (
    <section className="dashboard-products">
        <Connectors />
    </section>
)

export default ConnectorPanel
